/* ============================================================
   AM2T — card-product.js
   Product card hover video: when a card's 2nd media is a video,
   play it on mouseenter, pause + reset on mouseleave. Cards without
   video skip silently (CSS image swap handles the rest).
   Loaded by the sections that render cards (collection-grid,
   main-search). Depends on global.js (AM2T.onSection).
   ============================================================ */

(() => {
  'use strict';

  const bindCard = (card) => {
    if (card.dataset.hoverBound === 'true') return;
    card.dataset.hoverBound = 'true';

    const video = card.querySelector('[data-hover-video]');
    if (!video) return;

    card.addEventListener('mouseenter', () => {
      const p = video.play();
      if (p && typeof p.catch === 'function') p.catch(() => { /* autoplay blocked */ });
    });

    card.addEventListener('mouseleave', () => {
      video.pause();
      try { video.currentTime = 0; } catch { /* ignore */ }
    });
  };

  window.AM2T.onSection((root) => {
    root.querySelectorAll('.product-card').forEach(bindCard);
  });
})();
